import { cn } from "@/lib/utils";
import ReactCountryFlag from "react-country-flag";

export function RoundedCountryFlag({
  alpha_2,
  className,
}: {
  alpha_2: string;
  className?: string;
}) {
  return (
    <div
      className={cn("overflow-hidden mr-2 inline-block", className)}
      style={{
        display: "inline-block",
        lineHeight: 0,
      }}
    >
      <ReactCountryFlag
        countryCode={alpha_2}
        svg
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
}
